import { IAccountTotalsByDateRow, ReportColumnNames, ReportExtensions } from '@spa/api';

import {
    ReportTableColumn,
    ReportTableConfigInterface,
    ReportTableData,
    ReportTableDataRow
} from '../../../app/shared/components/report-table';

export const TotalsByDateEndBalanceRowId = 'totalsByDateEndBalance';

export const TotalsByDateReportTableConfig = (): ReportTableConfigInterface => {
    return {
        rows: [],
        columns: [
            new ReportTableColumn({
                label: 'Symbol',
                selector: ReportColumnNames.Symbol,
            }),
            new ReportTableColumn({
                label: 'Orders',
                selector: ReportColumnNames.Orders,
                shifted: true
            }),
            new ReportTableColumn({
                label: 'Fills',
                selector: ReportColumnNames.Fills,
                shifted: true
            }),
            new ReportTableColumn({
                label: 'Qty',
                selector: ReportColumnNames.Qty,
                shifted: true
            }),
            new ReportTableColumn({
                label: 'Gross',
                selector: ReportColumnNames.Gross,
                shifted: true
            }),
            new ReportTableColumn({
                label: 'Comm',
                selector: ReportColumnNames.COMM,
                shifted: true
            }),
            new ReportTableColumn({
                label: 'Ecn Fee',
                selector: ReportColumnNames.ECNFee,
                shifted: true
            }),
            new ReportTableColumn({
                label: 'SEC',
                selector: ReportColumnNames.SEC,
                shifted: true
            }),
            new ReportTableColumn({
                label: 'TAF',
                selector: ReportColumnNames.TAF,
                shifted: true
            }),
            new ReportTableColumn({
                label: 'NSCC',
                selector: ReportColumnNames.NSCC,
                shifted: true
            }),
            new ReportTableColumn({
                label: 'CLR',
                selector: ReportColumnNames.CLR,
                shifted: true
            }),
            new ReportTableColumn({
                label: 'ORF',
                selector: ReportColumnNames.ORF,
                shifted: true
            }),
            new ReportTableColumn({
                label: 'PTFPF',
                selector: ReportColumnNames.PTFPF,
                shifted: true
            }),
            new ReportTableColumn({
                label: 'EFTT',
                selector: ReportColumnNames.EFTT,
                shifted: true
            }),
            new ReportTableColumn({
                label: 'CAT',
                selector: ReportColumnNames.CAT,
                shifted: true
            }),
            new ReportTableColumn({
                label: 'Net',
                selector: ReportColumnNames.Net,
                shifted: true
            }),
            new ReportTableColumn({
                label: 'Unrealized',
                selector: ReportColumnNames.Unrealized,
                shifted: true
            })
        ],
        hiddenColumnIds: [],
        actionMenu: false,
        disableColumnsOptions: true
    };
};

export const TotalsByDateReportTableRow = (
    item: IAccountTotalsByDateRow,
    maxFraction = 6,
    minFraction = 2,
    rowLabel?: string
): ReportTableDataRow => {
    const transferOrFee = ['Fee', 'Transfer'].indexOf(item?.assetTypeId) >= 0;

    return new ReportTableDataRow({
        rowId: null,
        dataItems: [
            new ReportTableData({
                value: rowLabel
                    ?? (transferOrFee
                        ? `${item.assetTypeId}: ${item.symbol}`
                        : item?.symbol)
                    ?? '',
                colId: ReportColumnNames.Symbol,
                hidden: false,
                hasNegativeValue: false,
                class : "symbol-cell"
            }),
            getReportTableDataForInteger(ReportColumnNames.Orders),
            getReportTableDataForInteger(ReportColumnNames.Fills),
            getReportTableDataForDecimal(ReportColumnNames.Qty, 3, 3, true),
            getReportTableDataForDecimal(ReportColumnNames.Gross, 2, 2),
            getReportTableDataForDecimal(ReportColumnNames.COMM),
            getReportTableDataForDecimal(ReportColumnNames.ECNFee),
            getReportTableDataForDecimal(ReportColumnNames.SEC),
            getReportTableDataForDecimal(ReportColumnNames.TAF),
            getReportTableDataForDecimal(ReportColumnNames.NSCC),
            getReportTableDataForDecimal(ReportColumnNames.CLR),
            getReportTableDataForDecimal(ReportColumnNames.ORF),
            getReportTableDataForDecimal(ReportColumnNames.PTFPF),
            getReportTableDataForDecimal(ReportColumnNames.EFTT),
            getReportTableDataForDecimal(ReportColumnNames.CAT),
            getReportTableDataForDecimal(ReportColumnNames.Net, 2, 2),
            getReportTableDataForDecimal(ReportColumnNames.Unrealized, 2, 2),
        ]
    });

    function getReportTableDataForInteger(columnName: ReportColumnNames): ReportTableData {
        return new ReportTableData({
            value: getFormattedInteger(columnName),
            colId: columnName,
            hidden: false,
            hasNegativeValue: false,
            shifted: true
        });
    }

    function getReportTableDataForDecimal(
        columnName: ReportColumnNames,
        maximumFractionDigits = maxFraction,
        minimumFractionDigits = minFraction,
        removeFractionIfInteger:boolean = false): ReportTableData {
        return new ReportTableData({
            value: getFormattedDecimal(columnName, maximumFractionDigits, minimumFractionDigits, removeFractionIfInteger),
            colId: columnName,
            hidden: false,
            hasNegativeValue: !item ? false : ReportExtensions.isNegative(item[columnName]),
            shifted: true
        });
    }

    function getFormattedInteger(columnName: ReportColumnNames): string {
        return !item
            ? ReportColumnNames[columnName]
            : item[columnName] === null
                ? ''
                : ReportExtensions.toIntegerString(item[columnName]);
    }

    function getFormattedDecimal(
        columnName: ReportColumnNames,
        maximumFractionDigits: number,
        minimumFractionDigits: number,
        removeFractionIfInteger:boolean = false): string {
        return !item
            ? ReportColumnNames[columnName]
            : item[columnName] === null
                ? ''
                : ReportExtensions.toDecimalString(
                    item[columnName],
                    maximumFractionDigits,
                    minimumFractionDigits,
                    true,
                    removeFractionIfInteger);
    }
};
